import styled, { css } from 'styled-components';
import { HeaderMain } from '../../common/typography/typography.styles';

export const AuthWrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.namedColors.white};

  @media screen and (min-width: 650px) {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    justify-content: center;
    align-items: center;
    padding: 2.6rem;
  }
`;

export const AuthGreetingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 54rem;
  text-align: center;
  padding: 0 1rem;
  div:nth-child(1) {
    font-size: 5.5rem;
    font-weight: 700;
  }
  div:nth-child(2) {
    font-size: 3.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  div:nth-child(3) {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.baseColors.grey100};
  }
`;

export type ViewMode = 'page' | 'sidebar';

interface Props {
  $viewMode?: ViewMode;
  $isCentered?: boolean;
}

export const AuthContainer = styled.div<Props>`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
  padding: 4rem;
  border-radius: 2rem;
  min-height: auto;
  @media screen and (min-width: 650px) {
    max-width: 52.9rem;
  }

  ${({ $viewMode }) =>
    $viewMode === 'page' &&
    css`
      @media screen and (min-width: 650px) {
        border: 1px solid
          ${({ theme }) =>
            theme.colors.passwordValidationMarker.backgroundColor};
      }
    `}

  ${({ $isCentered }) =>
    !$isCentered &&
    css`
      @media (min-height: 800px) {
        min-height: 60rem;
      }
    `}

  ${HeaderMain} {
    text-align: center;
  }

  @media (max-width: 650px) {
    flex-grow: 1;
    padding: 2.4rem 1.6rem;
    margin-top: 0;
    border-radius: 0;
  }
`;

export const AuthButtonsHolder = styled.div`
  display: grid;
  gap: 1.6rem;
`;
